import { TApkAssignmentAction, ApkAssignmentActionTypes } from './apkAssignmentActions';
import { IApkAssignmentState } from './apkAssignmentContext';

export const apkAssignmentReducer = (state: IApkAssignmentState, action: TApkAssignmentAction): IApkAssignmentState => {
	switch (action.type) {
		case ApkAssignmentActionTypes.SET_APK_FOR_ASSIGN:
			return {
				...state,
				apkForAssign: action.payload.apkForAssign,
			};
		case ApkAssignmentActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				IDsSelectedApk: [],
				currentPage: 1,
			};
		case ApkAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS:
			return {
				...state,
				searchStringForAllCustomers: action.payload.searchStringForAllCustomers,
			};
		case ApkAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_RESTAURANTS:
			return {
				...state,
				searchStringForRestaurants: action.payload.searchStringForRestaurants,
			};
		case ApkAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_APK:
			return {
				...state,
				searchStringForApk: action.payload.searchStringForApk,
			};
		case ApkAssignmentActionTypes.CHANGE_TYPE_APK:
			return {
				...state,
				IDSelectedTypeApk: action.payload.IDSelectedTypeApk,
				IDsSelectedApk: [],
				isUnassignedApk: false,
				currentPage: 1,
			};
		case ApkAssignmentActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedTypeApk: null,
				isUnassignedApk: false,
				IDsSelectedApk: [],
				currentPage: 1,
				searchString: '',
			};
		case ApkAssignmentActionTypes.CHANGE_UNASSIGNED_APK_STATUS:
			return {
				...state,
				isUnassignedApk: action.payload.isUnassignedApk,
				IDsSelectedApk: [],
				currentPage: 1,
			};
		case ApkAssignmentActionTypes.SET_IDS_SELECTED_APK:
			return {
				...state,
				IDsSelectedApk: action.payload.IDsSelectedApk,
			};
		case ApkAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY:
			return {
				...state,
				activeItemToDisplay: action.payload.activeItemToDisplay,
			};
		case ApkAssignmentActionTypes.SET_SHOW_BREADCRUMBS:
			return {
				...state,
				isShowBreadcrumbs: action.payload.isShowBreadCrumbs,
			};
		case ApkAssignmentActionTypes.SET_ALL_CUSTOMERS:
			return {
				...state,
				allCustomers: action.payload.allCustomers,
			};
		case ApkAssignmentActionTypes.SET_IDS_SELECTED_CUSTOMERS:
			return {
				...state,
				IDsSelectedCustomers: action.payload.IDsSelectedCustomers,
				restaurants: action.payload.restaurants,
				IDsSelectedRestaurants: action.payload.IDsSelectedRestaurants,
				apk: action.payload.apk,
			};
		case ApkAssignmentActionTypes.SET_IDS_SELECTED_RESTAURANTS:
			return {
				...state,
				IDsSelectedRestaurants: action.payload.IDsSelectedRestaurants,
				apk: action.payload.apk,
			};
		case ApkAssignmentActionTypes.SET_APK:
			return {
				...state,
				apk: action.payload.apk,
				IDsSelectedApk: action.payload.IDsSelectedApk,
			};
		case ApkAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ApkAssignmentActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
				IDsSelectedApk: [],
			};
		case ApkAssignmentActionTypes.RESET_CHANGES:
			return {
				...state,
				activeItemToDisplay: 'customers',
				IDsSelectedCustomers: {},
				restaurants: [],
				IDsSelectedRestaurants: {},
				apk: [],
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
